import React from "react";

import { Box } from "@mui/material";
import { BigPlusIcon } from "assets/material-custom-icons";
import { SelectDeal } from "components/Measure-data";
import { Menu } from "components/popups";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

import { useAddMenuOptionsHook } from "./use-add-menu-options-hook";

export const AddMenu: React.FC = () => {
  const { options, isSelectDeal, setIsSelectDeal, allHidden } = useAddMenuOptionsHook();

  if (allHidden) return null;

  return (
    <>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Menu
          icon={
            <MaterialTooltip title="Quick actions menu" isShow>
              <BigPlusIcon />
            </MaterialTooltip>
          }
          iconButtonProps={{
            sx: {
              position: "relative",
              top: "20px",
              width: 40,
              height: 40,
              bgcolor: "#071F35",
              color: "#FFFFFF",
              borderRadius: "50%",
              ":hover": { bgcolor: "#071F35", color: "#FFFFFF" }
            }
          }}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          options={options}
        />
      </Box>
      <SelectDeal onSubmit={isSelectDeal} onCancel={() => setIsSelectDeal(null)} />
    </>
  );
};
